"use client"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { type ReactNode, useState, useEffect } from "react"
import { State, WagmiProvider } from "wagmi"

import { TooltipProvider } from "@/components/ui/tooltip"

import { getConfig } from "util/wagmiConfig"
import ConnectKitSIWEProvider from "./providers/ConnectKitSIWEProvider"
import { BreadcrumbContextProvider } from "./contexts/BreadcrumbContext"
import { initializeAmplitude } from "@/lib/utils/amplitude"
import { identifySentryByCookies } from "@/lib/utils/sentry"

type Props = {
  children: ReactNode
  initialWagmiState: State | undefined
}

const config = getConfig({ enableSSR: false })

/**
 * For proper Wagmi type-safety throughout
 * the codebase.
 */
declare module "wagmi" {
  interface Register {
    config: typeof config
  }
}

export function Providers({ children, initialWagmiState }: Props) {
  const [queryClient] = useState(() => new QueryClient())

  useEffect(() => {
    initializeAmplitude()
    identifySentryByCookies()
  }, [])

  {
    /** TODO(PAR-3122): Re-enable SSR when issue is fixed. **/
  }
  return (
    <>
      <TooltipProvider>
        <BreadcrumbContextProvider>
          <WagmiProvider config={config} initialState={initialWagmiState}>
            <QueryClientProvider client={queryClient}>
              <ConnectKitSIWEProvider>{children}</ConnectKitSIWEProvider>
            </QueryClientProvider>
          </WagmiProvider>
        </BreadcrumbContextProvider>
      </TooltipProvider>
    </>
  )
}
